
"use client";

import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../../../../components/navbar";
import Footer from "../../../../../components/footer";
import FilterSearch from "../../../../../components/FilterSearch(name)";
import Pagination from "../../../../../components/Pagination";
import styles from "../../css/CODTransactions/CODAccounts.module.css";
import { LuTruck } from "react-icons/lu";
import { getUnpaidCodAccounts } from "../../../../../api/frontShop/CODDebtorsAPI.js";

export default function CODAccounts() {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 6;

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    getUnpaidCodAccounts()
      .then((resp) => {
        const data = resp?.data?.data;
        const arr = Array.isArray(data) ? data : [];
        if (!alive) return;
        setRows(
          arr.map((r) => ({
            orderid: r.orderid,
            name: r.name || "",
            date: r.date || "",
            itemsCount: Number(r.itemsCount || 0),
            totalamount: Number(r.totalamount || 0).toFixed(2),
            status: String(r.status || "").trim(),
            inTransit: Boolean(r.inTransit),
          }))
        );
      })
      .catch(() => {
        if (!alive) return;
        setRows([]);
      })
      .finally(() => {
        if (!alive) return;
        setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, []);

  const filtered = useMemo(() => {
    const q = String(search || "").trim().toLowerCase();
    if (!q) return rows;
    return rows.filter(
      (r) =>
        String(r.name || "")
          .toLowerCase()
          .includes(q) || String(r.orderid || "").toLowerCase().includes(q)
    );
  }, [rows, search]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
  const pageRows = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return filtered.slice(start, start + pageSize);
  }, [filtered, currentPage]);

  return (
    <div className={styles.wrapper}>
      <Navbar backTo="/frontshop/debtors" />

      <div className={styles.container}>
        <div className={styles.titleRow}>
          <div className={styles.title}>COD Accounts</div>
        </div>

        <div className={styles.toolbarRow}>
          <FilterSearch
            filterName="Filter"
            value={search}
            onChange={(v) => {
              setCurrentPage(1);
              setSearch(v);
            }}
            placeholder="Search"
            wrapperClassName={styles.filterSearch}
            labelClassName={styles.filterSearchLabel}
            searchContainerClassName={styles.filterSearchInputWrap}
            searchInputClassName={styles.filterSearchInput}
            iconColor="#A78BFA"
          />
        </div>

        <div className={styles.list}>
          {pageRows.map((r) => (
            <button
              key={r.orderid}
              className={styles.row}
              onClick={() => {
                navigate("/frontshop/debtors/cod-accounts/payment", { state: { orderid: r.orderid } });
              }}
            >
              <div className={styles.left}>
                <div className={styles.iconWrap} aria-hidden="true">
                  <LuTruck />
                </div>
                <div className={styles.meta}>
                  <div className={styles.name}>{r.name}</div>
                  <div className={styles.subMeta}>
                    {r.date} · {r.itemsCount} items
                  </div>
                </div>
              </div>
              <div className={styles.right}>
                <div className={styles.pillsRow}>
                  <span
                    className={`${styles.pill} ${
                      String(r.status || "").toLowerCase() === "assigned"
                        ? styles.pillGreen
                        : String(r.status || "").toLowerCase() === "pending"
                          ? styles.pillOrange
                          : styles.pillGray
                    }`}
                  >
                    {r.status || "Unknown"}
                  </span>
                  <span className={`${styles.pill} ${r.inTransit ? styles.pillGreen : styles.pillRed}`}>
                    {r.inTransit ? "In Transit" : "Not Yet Shipped"}
                  </span>
                </div>
                <div className={styles.amount}>
                  {`R ${Number(r.totalamount).toLocaleString("en-ZA", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                </div>
              </div>
            </button>
          ))}
        </div>

        {loading && filtered.length === 0 ? <div className={styles.subTitle}>Loading...</div> : null}

        <div className={styles.paginationWrap}>
          <Pagination
            currentPage={Math.min(currentPage, totalPages)}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        </div>
      </div>

      <div className={styles.footerWrapper}>
        <Footer />
      </div>
    </div>
  );
}
